import config from "config";

export const authorizeBoxC = (responseType = 'token') => {
    window.location.href = `https://accounts.boxc.com/auth/v1/authorize?response_type=${responseType}&client_id=${config.boxcClientId}&redirect_uri=${config.boxcRedirectURI}`;
};